(function ($) {
  function animateResults($results) {
    const $items = $results.find('[data-home-news-item]');

    if (!$items.length) {
      return;
    }

    $results.removeClass('is-ready');
    $results.addClass('is-entering');

    $items.each(function (index) {
      this.style.transitionDelay = index * 70 + 'ms';
    });

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        $results.addClass('is-ready');
      });
    });

    window.setTimeout(function () {
      $results.removeClass('is-entering');

      $items.each(function () {
        this.style.transitionDelay = '';
      });
    }, 700);
  }

  $(function () {
    const $root = $('[data-home-news]');

    if (!$root.length || typeof HOME_NEWS_DATA === 'undefined') {
      return;
    }

    const $results = $root.find('[data-home-news-results]');
    let currentRequest = null;

    animateResults($results);

    $root.on('click', '[data-home-news-category]', function (event) {
      event.preventDefault();

      const $button = $(this);
      const previousCategory = $root
        .find('[data-home-news-category].is-active')
        .data('homeNewsCategory');
      const category = $button.data('homeNewsCategory') || '';

      if ($button.hasClass('is-active') || $results.hasClass('is-loading')) {
        return;
      }

      $root.find('[data-home-news-category]').removeClass('is-active');
      $root.find('[data-home-news-category]').attr('aria-pressed', 'false');
      $button.addClass('is-active');
      $button.attr('aria-pressed', 'true');
      $results.addClass('is-loading');

      if (currentRequest) {
        currentRequest.abort();
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'home-news-category-click',
        homeNewsCategory: category
      });

      currentRequest = $.ajax({
        type: 'POST',
        url: HOME_NEWS_DATA.ajaxUrl,
        data: {
          action: 'home_news_filter',
          category: category,
          nonce: HOME_NEWS_DATA.nonce
        },
        dataType: 'json'
      })
        .done(function (response) {
          if (!response || !response.success || !response.data.html) {
            throw new Error('Invalid response');
          }

          $results.html(response.data.html);
          animateResults($results);
        })
        .fail(function (xhr, status) {
          if (status === 'abort') {
            return;
          }

          $root.find('[data-home-news-category]').removeClass('is-active');
          $root.find('[data-home-news-category]').attr('aria-pressed', 'false');

          const $previousButton = $root.find(
            '[data-home-news-category="' + previousCategory + '"]'
          );

          if ($previousButton.length) {
            $previousButton.addClass('is-active');
            $previousButton.attr('aria-pressed', 'true');
          }
        })
        .always(function () {
          $results.removeClass('is-loading');
          currentRequest = null;
        });
    });
  });
})(jQuery);
